import React, { useContext } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';
import { useStore } from 'effector-react';
import includeSet from '@utils/includeSet';
import SvgIcon from '../SvgIcon';
import CollapseContext from './CollapseContext';
import { $collapse, $collapseApi } from './collapseStore';
import { TipWrapper } from '../TipWrapper';

interface Props {
  className?: string;
  dataPlace?: 'top' | 'bottom' | 'left' | 'right';
}

const IconOn = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M12.975 12v2h-6v-2h6zm-8-12v14h-2l-.001-1.086L0 9.939l1.414-1.414 1.56 1.561V0h2zm10 8v2h-8V8h8zm-4-4v2h-4V4h4zm5-4v2h-9V0h9z"
          id="collapse-on_svg__a"
        />
      </defs>
      <g transform="translate(0 1)" fill="none" fillRule="evenodd">
        <mask id="collapse-on_svg__b" fill="#fff">
          <use xlinkHref="#collapse-on_svg__a" />
        </mask>
        <use fill="#FFF" xlinkHref="#collapse-on_svg__a" />
        <path
          fill={color}
          mask="url(#collapse-on_svg__b)"
          d="M-5-5h25v25H-5z"
        />
      </g>
    </>
  ),
})``;

const IconOff = styled(SvgIcon).attrs({
  children: ({ color }: { color: string }) => (
    <>
      <defs>
        <path
          d="M12.975 12v2h-6v-2h6zm-8-12v14h-2L2.974 3.914l-1.56 1.56L0 4.062l2.974-2.975V0h2zm10 8v2h-8V8h8zm-4-4v2h-4V4h4zm5-4v2h-9V0h9z"
          id="collapse-off_svg__a"
        />
      </defs>
      <g transform="translate(0 1)" fill="none" fillRule="evenodd">
        <mask id="collapse-off_svg__b" fill="#fff">
          <use xlinkHref="#collapse-off_svg__a" />
        </mask>
        <use fill="#FFF" xlinkHref="#collapse-off_svg__a" />
        <path
          fill={color}
          mask="url(#collapse-off_svg__b)"
          d="M-5-5h25v25H-5z"
        />
      </g>
    </>
  ),
})``;

function CollapseToggle({ className, dataPlace = 'bottom' }: Props) {
  const { idSet } = useContext(CollapseContext);
  const openIds = useStore($collapse);
  const isAllOpen = includeSet(openIds, idSet);
  const renderIcon = () => {
    return isAllOpen ? (
      <IconOff onClick={() => $collapseApi.toggleAll({ idSet, isOn: false })} />
    ) : (
      <IconOn onClick={() => $collapseApi.toggleAll({ idSet, isOn: true })} />
    );
  };
  return (
    <div
      className={classNames(
        { 'inline-block': !!idSet.size, hidden: !idSet.size },
        className
      )}
    >
      <TipWrapper
        text={isAllOpen ? '全部收起' : '全部展开'}
        size="sm"
        placement={dataPlace}
      >
        {!!idSet.size && renderIcon()}
      </TipWrapper>
    </div>
  );
}

export default CollapseToggle;
